import { __assign } from "tslib";
import React from 'react';
import { themes } from '../../ThemeOptions';
import BTMenuItem from '../../bootstrap-components/components/BTMenuItem';
var bootStrapMenuItem = function (props) {
    return React.createElement(BTMenuItem, __assign({}, props));
};
var MenuItem = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapMenuItem(props);
            break;
        default:
            componentToDisplay = bootStrapMenuItem(props);
            break;
    }
    return (React.createElement(React.Fragment, null, componentToDisplay));
};
MenuItem.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(MenuItem);
//# sourceMappingURL=MenuItem.js.map